import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PRODUCT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { BookTypePage } from '@/features/product/pages/BookTypePage';
import { catalogueNameSearchSchema } from '@/features/product/types/product.types';

export const Route = createFileRoute('/_auth/product/book-types')({
  beforeLoad: () => requirePermission(PRODUCT_PERMISSIONS.BOOK_TYPE_VIEW),
  validateSearch: catalogueNameSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Book Type">
      <Suspense fallback={<PageLoader />}>
        <BookTypePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
